module.exports = __webpack_public_path__ + "fonts/almoni-light-aaa.f18141c.woff";